// compoents
import { FormElems, DatePicker, Alert, Modal, Accordion } from 'components';
import removeImg from '../../static/images/remove.png';
import downloadImg from '../../static/images/download.png';

// helpers
import { POST } from '../../utils/fetchWrappers';

// constatns
import {
    API_UPLOAD_KYC_DOCUMENT,
    API_VIEW_KYC_DOCUMENT,
} from '../../utils/API/apiUrls';
import { apiStatusCodes } from '../../utils/API/apiStatusCodes';
import { ERROR_MESSAGES } from '../../utils/constants/toastMessages';
import FakeLoader from '../../components/FakeLoader';
import {
    singleValueFields,
    multipleValuesFields,
    singleUploadFields,
    singleMultipleUploadFieldsIndividual,
    singleMultipleUploadFieldsSoleProp,
    multipleUploadFields,
    uboSingleUploadFields,
} from './constants';

// Validator
import validate from './validator';

// Importing Libs
import {
    createMerchantLegalEntityRequest,
    editMerchantLegalEntityRequest,
    fetchMerchantLegalEntityDetailsRequest,
    fetchMerchantLegalEntityDetailsPincodeRequest,
    resetMerchantLegalEntityFormReset,
} from './redux/merchantLegalEntity.actions';
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change, FieldArray } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { last } from 'lodash';
import moment from 'moment';
import { nameValueOptions } from 'utils/helperMethods';

let allowedExtensions = ['jpg', 'jpeg', 'png', 'svg', 'pdf'];
let smallTurnoverCategoryAmount = 400000;
let largeTurnoverCategoryAmount = 700000;

const MerchantLegalEntityMutate = ({
    isViewMode,
    handleSubmit,
    actions,
    isEditMode,
    history,
    mutateFormData,
    initialValues,
    merchantLegalEntityData,
    staticData
}) => {
    console.log("merchantLegalEntityData",merchantLegalEntityData.error.error?.statusCode);
    const [multipleDocUrls, setMultipleDocUrls] = useState({
        CERTIFICATE_OF_INCORPORATION: [],
        CANCELLED_CHEQUE: [],
        PAN: [],
        GST: [],
        MEMORANDUM_OF_ASSOCIATION: [],
        PARTNERSHIP_DEED: [],
        BO_DECLARATION: [],
        BO_ADDRESS: [],
        PRIVACY_POLICY: [],
        BO_IDENTITY_PROOF: [],
        PROOF_OF_ADDRESS: [],
        SHOP_PICS:[],
        RESOLUTION_OF_THE_MANAGING_BODY:[],
        PROOF_PRINCIPLE_PLACE: [],
        MEA: [],
        BR:[],
        AGREEMENT: [],
        NGO_REGISTRATION:[],
        WEBSITE_TERMS_AND_CONDITION: [],
        REFUND_POLICY: [],
        CUSTOMER_GRIEVANCE_POLICY: [],
        ARTICLE_OF_ASSOCIATION: [],
        AUTHORISED_SIGNATORY_ADDRESS: [],
        PROOF_BUSINESS_1: [],
        PROOF_BUSINESS_2: [],
        AUTHORISED_PAN:[],
        REGISTRATION_CERTIFICATE: [],
        LISTS_OF_PEOPLE: [],
        TRUST_DEED: [],
        WEB_CRAWLING: [],
        POWER_OF_ATTORNEY: [],
        UNI_CA_MOA_PARTNERSHIP_DEED: [],
        JURIDICAL_PERSON_MOA: [],
        RBI_LICENSE: [],
        CHANNELS: [],
        LOB_VERIFICATION: [],
        OWNERSHIP_CHECK: [],
        RESTRICTED_STATES: [],
        TRACK_RECORD_1_YEAR: [],
        UNDERTAKING_MERCHANT_2: [],
        MAIL_APPROVAL_SCREENSHOT: [],
        AUTHORISED_SIGNATORY_SELFIE: [],
        AUTHORISED_SIGNATORY_PAN: [],
        ALL_MCA_PRODUCTS: [],
        MCA_REGISTRATION: [],
        COPYRIGHT: [],
        WEBSITE_REDIRECTION: [],
        MERCHANT_APPLICATION_FORM:[],
        BANK_PROOF: [],
        PERMANENT_ACCOUNT_NUMBER:[]
    });
    const [isUploading, setIsUploading] = useState(false);
    const [expirytDate, setExpiryDate] = useState(null);
    const [focusedInput, setFocusedInput] = useState(null);
    const [dateOfIncorporation, setDateOfIncorporation] = useState(null);
    
    const [
        dateOfIncorporationfocusedInput,
        setDateOfIncorporationFocusedInput,
    ] = useState(null);
    const [selectedDocument, setSelectedDocument] = useState(null);

    const [authorisedSignatoryDob, setAuthorisedSignatoryDob] = useState(null);
    const [
        authorisedSignatoryDobInput,
        setAuthorisedSignatoryDobInput,
    ] = useState(null);

    const [errors, setErrors] = useState({});
    const [selectedBusinessType, setSelectedBusinessType] = useState('');
    const [pinCodeValue, setPinCodeValue] = useState('')

      // Handle change of business type
      const handleBusinessTypeChange = (event) => {
        
        setSelectedBusinessType(event);
        if(event === 'Individual' || event === 'sole proprietorship'){
            allowedExtensions = ['jpg', 'jpeg', 'png', 'svg', 'pdf', 'doc', 'docx', 'msword', 'tiff', 'pipeg', 'gif', , 'bmp', 'wordprocessingml.document'];
        }
        else {
            allowedExtensions = ['jpg', 'jpeg', 'png', 'svg', 'pdf'];
        }
        setErrors({});
    };

    // Create a ref to access the Field component
    const fieldRef = useRef(null);

    useEffect(() => {
        // Check if the item is the correct one and fieldRef is available

        if(merchantLegalEntityData?.editData){
            
            !selectedBusinessType && setSelectedBusinessType(merchantLegalEntityData?.editData?.businessType);
        }
        if(merchantLegalEntityData?.editData?.businessType === 'Individual' || merchantLegalEntityData?.editData?.businessType === 'sole proprietorship'){
            allowedExtensions = ['jpg', 'jpeg', 'png', 'svg', 'pdf', 'doc', 'docx', 'msword', 'tiff', 'pipeg', 'gif', , 'bmp', 'wordprocessingml.document'];
        }
        else {
            allowedExtensions = ['jpg', 'jpeg', 'png', 'svg', 'pdf'];
        }
        
    }, [merchantLegalEntityData]);



    const requiredFieldsByBusinessType = {
        'Individual': [],
        'Company - public/private ltd': [ ],
        'trust': [],
        'unincorporated association or a body of individuals': [],
        'Cooperative Bank': [],
        'Partnership firm/LLP': [],
        'sole proprietorship': [],
        'juridical person': [],
        };

    const getFilteredSingleUploadFields = (filteredType) => {
    // Define default required fields based on the selected business type
    const requiredFields = requiredFieldsByBusinessType[selectedBusinessType] || [];

    // Initialize finalComponent as an empty array
    let finalComponent = [];

    filteredType.forEach(field => {
        // Create a new object to hold the field data

        const newField = {
            ...field,  // Spread existing properties
            props: {
                ...field.props,  // Spread existing props
                required: requiredFields.includes(field.name)  // Set required based on condition
            }
        };

        // Push the new field object into finalComponent
        finalComponent.push(newField);
    });

    // Filter the fields based on business type
    finalComponent = finalComponent.filter(field => {
        if (selectedBusinessType === 'Individual') {
            return ['BO_ADDRESS', 'SHOP_PICS', 'AUTHORISED_SIGNATORY_SELFIE'].includes(field.name);
        }
        else if (selectedBusinessType === 'sole proprietorship') {
            return ['BO_ADDRESS', 'GST', 'PROOF_BUSINESS_1', 'PROOF_BUSINESS_2', 'SHOP_PICS', 'AUTHORISED_SIGNATORY_SELFIE'].includes(field.name);
        }

        else if (selectedBusinessType === 'Company - public/private ltd') {
            return ['MEA', 'AGREEMENT', 'PERMANENT_ACCOUNT_NUMBER', 'BANK_PROOF', 'BO_DECLARATION', 'LISTS_OF_PEOPLE', 'CERTIFICATE_OF_INCORPORATION', 'MEMORANDUM_OF_ASSOCIATION', 'ARTICLE_OF_ASSOCIATION', 'BR', 'PROOF_BUSINESS_2', 'GST', 'AUTHORISED_SIGNATORY_PAN', 'AUTHORISED_SIGNATORY_SELFIE', 'AUTHORISED_SIGNATORY_ADDRESS', 'PRIVACY_POLICY', 'REFUND_POLICY', 'WEBSITE_TERMS_AND_CONDITION', 'CHANNELS', 'LOB_VERIFICATION', 'OWNERSHIP_CHECK', 'WEBSITE_REDIRECTION', 'COPYRIGHT', 'UNDERTAKING_MERCHANT_2', 'RESTRICTED_STATES', 'MCA_REGISTRATION'].includes(field.name);
        }

        else if (selectedBusinessType === 'Partnership firm/LLP') {
            return ['MEA', 'AGREEMENT', 'PERMANENT_ACCOUNT_NUMBER', 'BANK_PROOF', 'LISTS_OF_PEOPLE', 'BO_DECLARATION', 'PARTNERSHIP_DEED', 'REGISTRATION_CERTIFICATE', 'GST', 'POWER_OF_ATTORNEY', 'AUTHORISED_SIGNATORY_PAN', 'AUTHORISED_SIGNATORY_SELFIE', 'AUTHORISED_SIGNATORY_ADDRESS', 'CERTIFICATE_OF_INCORPORATION', 'PRIVACY_POLICY', 'REFUND_POLICY', 'WEBSITE_TERMS_AND_CONDITION', 'CHANNELS', 'LOB_VERIFICATION', 'OWNERSHIP_CHECK', 'WEBSITE_REDIRECTION', 'COPYRIGHT', 'UNDERTAKING_MERCHANT_2', 'RESTRICTED_STATES', 'MCA_REGISTRATION'].includes(field.name);
        }

        else if (selectedBusinessType === 'trust') {
            return ['MEA', 'AGREEMENT', 'PERMANENT_ACCOUNT_NUMBER', 'BANK_PROOF', 'LISTS_OF_PEOPLE', 'BO_DECLARATION', 'NGO_REGISTRATION', 'REGISTRATION_CERTIFICATE', 'TRUST_DEED', 'POWER_OF_ATTORNEY', 'AUTHORISED_SIGNATORY_SELFIE', 'AUTHORISED_SIGNATORY_ADDRESS', 'AUTHORISED_SIGNATORY_PAN', 'GST', 'REFUND_POLICY', 'PRIVACY_POLICY', 'WEBSITE_TERMS_AND_CONDITION', 'CHANNELS', 'LOB_VERIFICATION', 'OWNERSHIP_CHECK', 'WEBSITE_REDIRECTION', 'COPYRIGHT'].includes(field.name);
        }

        else if(selectedBusinessType === 'unincorporated association or a body of individuals'){
            return ['MERCHANT_APPLICATION_FORM', 'AGREEMENT', 'CANCELLED_CHEQUE', 'LISTS_OF_PEOPLE', 'BO_DECLARATION', 'PERMANENT_ACCOUNT_NUMBER', 'RESOLUTION_OF_THE_MANAGING_BODY', 'POWER_OF_ATTORNEY', 'PROOF_OF_ADDRESS', 'AUTHORISED_SIGNATORY_SELFIE', 'AUTHORISED_SIGNATORY_ADDRESS', 'AUTHORISED_SIGNATORY_PAN', 'UNI_CA_MOA_PARTNERSHIP_DEED', 'GST', 'REGISTRATION_CERTIFICATE', 'REFUND_POLICY', 'PRIVACY_POLICY', 'WEBSITE_TERMS_AND_CONDITION', 'CHANNELS', 'LOB_VERIFICATION', 'OWNERSHIP_CHECK', 'WEBSITE_REDIRECTION', 'COPYRIGHT'].includes(field.name);
        }

        else if (selectedBusinessType === 'Cooperative Bank') {
            return ['MEA', 'AGREEMENT', 'CANCELLED_CHEQUE', 'LISTS_OF_PEOPLE', 'BO_DECLARATION', 'PAN', 'RBI_LICENSE','POWER_OF_ATTORNEY', 'PROOF_BUSINESS_1', 'AUTHORISED_SIGNATORY_PAN', 'AUTHORISED_SIGNATORY_SELFIE', 'AUTHORISED_SIGNATORY_ADDRESS', 'PRIVACY_POLICY', 'REFUND_POLICY', 'WEBSITE_TERMS_AND_CONDITION', 'CHANNELS', 'LOB_VERIFICATION', 'OWNERSHIP_CHECK', 'WEBSITE_REDIRECTION', 'COPYRIGHT', 'REGISTRATION_CERTIFICATE'].includes(field.name);
        }

        else if (selectedBusinessType === 'juridical person') {
            return ['MERCHANT_APPLICATION_FORM', 'AGREEMENT', 'CANCELLED_CHEQUE', 'LISTS_OF_PEOPLE', 'PAN', 'POWER_OF_ATTORNEY', 'PROOF_OF_ADDRESS', 'AUTHORISED_SIGNATORY_PAN', 'AUTHORISED_SIGNATORY_SELFIE', 'AUTHORISED_SIGNATORY_ADDRESS', 'JURIDICAL_PERSON_MOA', 'GST', 'REGISTRATION_CERTIFICATE', 'RBI_LICENSE'].includes(field.name);
        }

        // Add other conditions as needed
        return true; // Return all fields or a default set
    });

    return finalComponent;
};

    const capturePincodeFun = (event) => {
        
        setPinCodeValue(event);
    }

    const { location } = history;

    useEffect(() => {
        const entityCode = last(location.pathname.split('/'));
        if ((isEditMode || isViewMode) && entityCode) {
            actions.fetchMerchantLegalEntityDetailsRequest({ entityCode });
        }
    }, [actions, isEditMode, isViewMode, location.pathname]);


    // useEffect(() => {
    //     
    //      if( pinCodeValue && pinCodeValue?.split("")?.length === 6 ) {
    //         
    //         // actions.fetchMerchantLegalEntityDetailsPincodeRequest({ pinCodeValue });
    //      }
    // }, [pinCodeValue])

    
    useEffect(() => {
        const entityCode = last(location.pathname.split('/'));
        if (
            (isEditMode || isViewMode) &&
            initialValues &&
            initialValues.docUrls
        ) {
            setMultipleDocUrls({
                ...multipleDocUrls,
                ...initialValues.docUrls,
            });
        }

        if (
            (isEditMode || isViewMode) &&
            initialValues &&
            initialValues.agreementExpiry
        ) {
            setExpiryDate(initialValues.agreementExpiry);
        }

        if (
            (isEditMode || isViewMode) &&
            initialValues &&
            initialValues.dateOfIncorporation
        ) {
            setDateOfIncorporation(initialValues.dateOfIncorporation);
        }

        if (
            (isEditMode || isViewMode) &&
            initialValues &&
            initialValues.authorisedSignatoryDob
        ) {
            setAuthorisedSignatoryDob(initialValues.authorisedSignatoryDob);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actions, isEditMode, location.pathname, initialValues, isViewMode]);

    useEffect(() => {
        console.log(merchantLegalEntityData.error?.error?.statusCode);
        console.log(merchantLegalEntityData.error?.error?.errorMessage);

        if (isEditMode && merchantLegalEntityData.isSuccess) {
            toast.success('MLE Updated Successfully');
            history.push('/mle-onboarding');
        } else if (merchantLegalEntityData.isSuccess) {
            toast.success('MLE Created Successfully');
            history.push('/mle-onboarding');
        }
        else if(merchantLegalEntityData.error?.error?.statusCode === 'ER-7100' || merchantLegalEntityData.error?.error?.statusCode === 'SPGM-0002')
           {
            toast.error('MLE ID could not be found.');
            history.push('/mle-onboarding');
          }
          else if (merchantLegalEntityData.error?.error?.errorMessage?.includes('Service Currently unavailable')) {
            toast.error('MLE ID could not be found.');
            history.push('/mle-onboarding');
          }
    }, [
        merchantLegalEntityData.editData,
        merchantLegalEntityData.createData,
        isEditMode,
        history,
        isViewMode,
        merchantLegalEntityData.isSuccess,
        merchantLegalEntityData.error?.error?.statusCode
    ]);

    async function uploadImageAndGetURL(file, name) {
        if (
            !(
                mutateFormData?.values?.emailIds?.length &&
                mutateFormData?.values?.emailIds[0]
            )
        ) {
            toast.error(ERROR_MESSAGES.PLEASE_ENTER_EMAIL_ID);
            return;
        }

        setIsUploading(true);
        const formData = new FormData();
        formData.append('multipartFile', file);
        formData.append(
            'uniqueIdentifier',
            `${mutateFormData.values.emailIds[0]}_${new Date().getTime()}`
        );

        try {
            const response = await POST(
                API_UPLOAD_KYC_DOCUMENT,
                formData,
                {
                    'Content-Type': 'multipart/form-data;',
                },
                true
            );

            const { data } = response;

            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                toast.info('File upload successful');
                setIsUploading(false);
                return data.s3Path;
            }
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        } catch (error) {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        }
        setIsUploading(false);
    }

    async function handleViewClick(docUrl) {
        const request = {
            s3Path: docUrl,
        };
        try {
            setIsUploading(true);
            const response = await POST(
                API_VIEW_KYC_DOCUMENT,
                request,
                {},
                true
            );
            const { data } = response;
            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                if (data.s3Url.toLowerCase().includes('.pdf')) {
                    window.open(data.s3Url);
                } else {
                    setSelectedDocument(data.s3Url);
                }
            } else {
                toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
            }
            setIsUploading(false);
        } catch (error) {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
            setIsUploading(false);
        }
    }

    const handleFormSubmit = values => {
        const newErrors = {};
        const request = {
            entityType: 'MLE',
            mode: 'LIVE',
            remarks: values?.remarks,
            kycStatus: values?.kycStatus || 'PENDING',
        };

        const docUrlMap = {};

        singleValueFields.forEach(field => {
            if (values[field.name]) {
                request[field.name] = values[field.name];
            }
        });

        multipleValuesFields.forEach(field => {
            if (values[field.name] && values[field.name].length) {
                request[field.name] = values[field.name];
            }
        });

        singleMultipleUploadFieldsIndividual.forEach(field => {
            
            if (values[field.name] && values[field.name].length) {
                request[field.name] = values[field.name];
            }
        });

        singleMultipleUploadFieldsSoleProp.forEach(field => {
            
            if (values[field.name] && values[field.name].length) {
                request[field.name] = values[field.name];
            }
        });

        // singleMultipleFilteredFieldsSoleProp.forEach(field => {
        //     if (values[field.name] && values[field.name].length) {
        //         request[field.name] = values[field.name];
        //     }
        // });

        // Get filtered fields based on the selected business type
        const singleFilteredFields = getFilteredSingleUploadFields(singleUploadFields);
        const multipleFilteredFields = getFilteredSingleUploadFields(multipleUploadFields);

        singleFilteredFields.forEach(field => {
            
            if (field.props.required && (!multipleDocUrls[field.name] || !multipleDocUrls[field.name].length || values[field.name][0] === null)) {
                newErrors[field.name] = `${field.label} is a required document`;
            } else if (values[field.name] && multipleDocUrls[field.name].length && values[field.name][0] !== null) {
                docUrlMap[field.name] = multipleDocUrls[field.name];
            }
        });

        (selectedBusinessType === 'Individual') && singleMultipleUploadFieldsIndividual.forEach(field => {
            
            let validFileUrls = [];
            
            // Check if the field is required and process the files
            if (field.props.required) {
                let hasValidFiles = false;
                
                // Loop through each file value
                values[field.name].forEach((file, index) => {
                    if (file !== null) {
                        validFileUrls.push(multipleDocUrls[field.name][index]);
                        hasValidFiles = true;
                    }
                });
        
                if (validFileUrls.length === 0) {
                    newErrors[field.name] = `${field.label} is a required document`;
                } else {
                    docUrlMap[field.name] = validFileUrls;
                }
            } else {
                // If the field is not required, just process the valid files
                values[field.name].forEach((file, index) => {
                    console.log("🚀 ~ values[field.name].forEach ~ file:", file)
                    
                    if (file !== null && file !== undefined ) {
                        validFileUrls.push(multipleDocUrls[field.name][index]);
                    }
                });
                
                if (validFileUrls.length > 0) {
                    docUrlMap[field.name] = validFileUrls;
                }
            }
        });

        (selectedBusinessType === 'sole proprietorship') && singleMultipleUploadFieldsSoleProp.forEach(field => {
            
            let validFileUrls = [];
            
            // Check if the field is required and process the files
            if (field.props.required) {
                let hasValidFiles = false;
                
                // Loop through each file value
                values[field.name].forEach((file, index) => {
                    if (file !== null) {
                        validFileUrls.push(multipleDocUrls[field.name][index]);
                        hasValidFiles = true;
                    }
                });
        
                if (validFileUrls.length === 0) {
                    newErrors[field.name] = `${field.label} is a required document`;
                } else {
                    docUrlMap[field.name] = validFileUrls;
                }
            } else {
                // If the field is not required, just process the valid files
                values[field.name].forEach((file, index) => {
                    if (file !== null) {
                        validFileUrls.push(multipleDocUrls[field.name][index]);
                    }
                });
                
                if (validFileUrls.length > 0) {
                    docUrlMap[field.name] = validFileUrls;
                }
            }
        });
    
        multipleFilteredFields.forEach(field => {
            if (field.props.required && (!multipleDocUrls[field.name] || !multipleDocUrls[field.name].length || values[field.name][0] === null)) {
                newErrors[field.name] = `${field.label} is a required document`;
            } else if (values[field.name] && multipleDocUrls[field.name].length && values[field.name][0] !== null) {
                docUrlMap[field.name] = multipleDocUrls[field.name];
            }
        });
        
        if (Object.keys(newErrors).length) {
            setErrors(newErrors);
            return;
        }

        if (docUrlMap && Object.keys(docUrlMap).length) {
            request.nameVsDocUrls = docUrlMap;
        }

        if (expirytDate) {
            request.agreementExpiry = moment(expirytDate)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
        }

        if (dateOfIncorporation) {
            request.dateOfIncorporation = moment(dateOfIncorporation)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
        }

        if (authorisedSignatoryDob) {
            request.authorisedSignatoryDob = moment(authorisedSignatoryDob)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
        }

        if (values.uboDetails) {
            let updatedDocUrls = [];
            values.uboDetails.forEach(item => {
                let data = { ...item, ...item.docUrls };
                delete data.docUrls;
                delete data.uboDOBDate;
                updatedDocUrls.push(data);
            });
            request.uboDetails = updatedDocUrls;
        }

        if (isEditMode) {
            const entityCode = last(location.pathname.split('/'));
            request.entityCode = entityCode;

            actions.editMerchantLegalEntityRequest(request);
        } else {
            actions.createMerchantLegalEntityRequest(request);
        }
    };

    // useEffect(() => {
    //     let merchantTurnOver = mutateFormData?.values?.turnOver;
    //     let merchantType = mutateFormData?.values?.merchantType;
    //     let gstNumber = mutateFormData?.values?.gstNumber;
    //     let gstDoc = multipleDocUrls.GST;

    //     if (
    //         merchantTurnOver < smallTurnoverCategoryAmount &&
    //         merchantType === 'Offline'
    //     ) {
    //         actions.change('mle-onboarding-form', 'merchantCategory', 'Small');
    //     } else if (
    //         merchantTurnOver >= smallTurnoverCategoryAmount &&
    //         merchantTurnOver < largeTurnoverCategoryAmount
    //     ) {
    //         actions.change('mle-onboarding-form', 'merchantCategory', 'Medium');
    //     } else if (
    //         merchantTurnOver >= smallTurnoverCategoryAmount ||
    //         (gstDoc && gstDoc.length > 0 && gstNumber && gstNumber.length > 0)
    //     ) {
    //         actions.change('mle-onboarding-form', 'merchantCategory', 'Large');
    //     }
    // }, [
    //     mutateFormData?.values?.gstNumber,
    //     mutateFormData?.values?.turnOver,
    //     multipleDocUrls.GST,
    //     mutateFormData?.values?.merchantType,
    // ]);

    const formError =
        mutateFormData.syncErrors && mutateFormData.syncErrors.commonErrors;

    const resetFieldError = (fieldName) => {
        setErrors(prevErrors => ({
            ...prevErrors,
            [fieldName]: null
        }));
    };

    const getFieldOrderForBusinessType = (businessType) => {
        const fieldOrderMapping = {

            'Individual': ['BO_ADDRESS', 'SHOP_PICS', 'AUTHORISED_SIGNATORY_SELFIE'],

            'sole proprietorship': ['BO_ADDRESS', 'GST', 'PROOF_BUSINESS_1', 'PROOF_BUSINESS_2', 'SHOP_PICS', 'AUTHORISED_SIGNATORY_SELFIE'],
            
            'Company - public/private ltd': [
                'MEA', 'AGREEMENT', 'PERMANENT_ACCOUNT_NUMBER', 'BANK_PROOF', 'BO_DECLARATION', 'LISTS_OF_PEOPLE',
                'CERTIFICATE_OF_INCORPORATION', 'MEMORANDUM_OF_ASSOCIATION', 'ARTICLE_OF_ASSOCIATION', 'BR',
                'GST', 'AUTHORISED_SIGNATORY_PAN', 'AUTHORISED_SIGNATORY_SELFIE',
                'AUTHORISED_SIGNATORY_ADDRESS', 'PRIVACY_POLICY', 'REFUND_POLICY', 'WEBSITE_TERMS_AND_CONDITION',
                'CHANNELS', 'LOB_VERIFICATION', 'OWNERSHIP_CHECK', 'WEBSITE_REDIRECTION', 'COPYRIGHT',
                'UNDERTAKING_MERCHANT_2', 'RESTRICTED_STATES', 'MCA_REGISTRATION'
            ],
            
            'unincorporated association or a body of individuals': ['MERCHANT_APPLICATION_FORM', 'AGREEMENT', 'CANCELLED_CHEQUE', 'LISTS_OF_PEOPLE', 'BO_DECLARATION', 'PERMANENT_ACCOUNT_NUMBER', 'RESOLUTION_OF_THE_MANAGING_BODY', 'POWER_OF_ATTORNEY', 'PROOF_OF_ADDRESS', 'AUTHORISED_SIGNATORY_SELFIE', 'AUTHORISED_SIGNATORY_ADDRESS', 'AUTHORISED_SIGNATORY_PAN', 'UNI_CA_MOA_PARTNERSHIP_DEED', 'GST', 'REGISTRATION_CERTIFICATE', 'REFUND_POLICY', 'PRIVACY_POLICY', 'WEBSITE_TERMS_AND_CONDITION', 'CHANNELS', 'LOB_VERIFICATION', 'OWNERSHIP_CHECK', 'WEBSITE_REDIRECTION', 'COPYRIGHT'],
            
            'Partnership firm/LLP': [
                'MEA', 'AGREEMENT', 'PERMANENT_ACCOUNT_NUMBER', 'BANK_PROOF', 'LISTS_OF_PEOPLE', 'BO_DECLARATION', 'PARTNERSHIP_DEED',
                'REGISTRATION_CERTIFICATE', 'GST', 'POWER_OF_ATTORNEY', 'AUTHORISED_SIGNATORY_PAN',
                'AUTHORISED_SIGNATORY_SELFIE', 'AUTHORISED_SIGNATORY_ADDRESS', 'CERTIFICATE_OF_INCORPORATION', 'PRIVACY_POLICY', 'REFUND_POLICY',
                'WEBSITE_TERMS_AND_CONDITION', 'CHANNELS', 'LOB_VERIFICATION', 'OWNERSHIP_CHECK',
                'WEBSITE_REDIRECTION', 'COPYRIGHT', 'UNDERTAKING_MERCHANT_2', 'RESTRICTED_STATES', 'MCA_REGISTRATION'
            ],
            'trust': [
                'MEA', 'AGREEMENT', 'PERMANENT_ACCOUNT_NUMBER', 'BANK_PROOF', 'LISTS_OF_PEOPLE', 'BO_DECLARATION', 'NGO_REGISTRATION',
                'REGISTRATION_CERTIFICATE', 'TRUST_DEED', 'POWER_OF_ATTORNEY', 'AUTHORISED_SIGNATORY_SELFIE',
                'AUTHORISED_SIGNATORY_ADDRESS', 'AUTHORISED_SIGNATORY_PAN', 'GST', 'REFUND_POLICY', 'PRIVACY_POLICY',
                'WEBSITE_TERMS_AND_CONDITION', 'CHANNELS', 'LOB_VERIFICATION', 'OWNERSHIP_CHECK', 'WEBSITE_REDIRECTION',
                'COPYRIGHT'
            ],
            'juridical person': [
                'MERCHANT_APPLICATION_FORM', 'AGREEMENT', 'CANCELLED_CHEQUE', 'LISTS_OF_PEOPLE', 'PAN', 'POWER_OF_ATTORNEY', 'PROOF_OF_ADDRESS', 'AUTHORISED_SIGNATORY_PAN', 'AUTHORISED_SIGNATORY_SELFIE', 'AUTHORISED_SIGNATORY_ADDRESS', 'JURIDICAL_PERSON_MOA', 'GST', 'REGISTRATION_CERTIFICATE', 'RBI_LICENSE'
            ],
            // Add more types as necessary
        };
    
        return fieldOrderMapping[businessType] || [];
    };
    

    const getSortedFields = (fields, businessType) => {
        const order = getFieldOrderForBusinessType(businessType);
        const orderMap = new Map(order.map((name, index) => [name, index]));
    
        // Sort fields based on the order map
        return fields.slice().sort((a, b) => {
            const indexA = orderMap.get(a.name);
            const indexB = orderMap.get(b.name);
    
            if (indexA === undefined) return 1; // Place fields not in the order map at the end
            if (indexB === undefined) return -1;
            return indexA - indexB;
        });
    };

    const sortedFields = getSortedFields(singleUploadFields, selectedBusinessType);
    const sortedSingleMultipleFieldsIndividual = getSortedFields(singleMultipleUploadFieldsIndividual, selectedBusinessType);
    const sortedSingleMultipleFieldsSoleProp = getSortedFields(singleMultipleUploadFieldsSoleProp, selectedBusinessType);

    return (
        <div className="merchant-legal-entity-onboarding-wrapper">
            <Modal
                modalIsOpen={selectedDocument}
                shouldCloseOnOverlayClick
                shouldCloseOnEsc
                closeModal={() => setSelectedDocument(null)}
                customWrapperClass="content-modal modal-xl"
            >
                <div className="modal-header">
                    <h2 className="modal-heading">Document View</h2>
                    <img
                        src={removeImg}
                        alt="Close"
                        onClick={() => setSelectedDocument(null)}
                    />
                </div>
                <div className="modal-body" role="dialog" aria-modal="true">
                    {selectedDocument && selectedDocument.includes('.pdf') ? (
                        <iframe
                            src={selectedDocument}
                            frameBorder="0"
                            scrolling="auto"
                            height="100%"
                            width="100%"
                        ></iframe>
                    ) : (
                        <img
                            src={selectedDocument}
                            className="document-image"
                            alt="selectedDocument"
                        />
                    )}
                    <img
                        src={downloadImg}
                        alt="Downlaod"
                        className="download-image"
                        onClick={() => window.open(selectedDocument)}
                    />
                </div>
            </Modal>
            {isUploading || merchantLegalEntityData.isLoading ? (
                <FakeLoader withMask />
            ) : null}
            <h2 className="title">MLE Onboarding</h2>
            <form
                className="mle-onboarding-form"
                onSubmit={handleSubmit(handleFormSubmit)}
            >
                <ul className="form-list">
                    <Accordion
                        customClass="rounded-accordion"
                        upperComponent={
                            <h2 className="accordion-tile">MLE Information</h2>
                        }
                        lowerComponent={
                            <>
                                <li className="form-section">
                                    {singleValueFields.map((item, index) => {
    
                                        return (
                                            <div
                                                className="form-field"
                                                key={index}
                                            >
                                                <p className="label">
                                                    {item.label}
                                                    {item?.required && <span className="required-asterisk">*</span>}
                                                </p>
                                                {item.name ===
                                                'agreementExpiry' ? (
                                                    <Field
                                                        name={item.name}
                                                        component={DatePicker}
                                                        singleDatePicker
                                                        startDateId={item.name}
                                                        onFocusedInput={
                                                            setFocusedInput
                                                        }
                                                        onSetStartDate={
                                                            setExpiryDate
                                                        }
                                                        
                                                        startDate={expirytDate}
                                                        focusedInput={
                                                            focusedInput
                                                        }
                                                        displayFormat="DD/MM/YYYY"
                                                        disabled={isViewMode}
                                                        isOutsideRange={day =>
                                                            false
                                                        }
                                                    />
                                                ) : item.name ===
                                                  'dateOfIncorporation' ? (
                                                    <Field
                                                        name={item.name}
                                                        component={DatePicker}
                                                        singleDatePicker
                                                        startDateId={item.name}
                                                        onFocusedInput={
                                                            setDateOfIncorporationFocusedInput
                                                        }
                                                        onSetStartDate={
                                                            setDateOfIncorporation
                                                        }
                                                        startDate={
                                                            dateOfIncorporation
                                                        }
                                                        focusedInput={
                                                            dateOfIncorporationfocusedInput
                                                        }
                                                        displayFormat="DD/MM/YYYY"
                                                        disabled={isViewMode}
                                                        isOutsideRange={day =>
                                                            day.isAfter(
                                                                moment().endOf(
                                                                    'day'
                                                                )
                                                            )
                                                        }
                                                    />
                                                ) : item.name ===
                                                  'authorisedSignatoryDob' ? (
                                                    <Field
                                                        name={item.name}
                                                        component={DatePicker}
                                                        singleDatePicker
                                                        startDateId={item.name}
                                                        onFocusedInput={
                                                            setAuthorisedSignatoryDobInput
                                                        }
                                                        onSetStartDate={
                                                            setAuthorisedSignatoryDob
                                                        }
                                                        startDate={
                                                            authorisedSignatoryDob
                                                        }
                                                        focusedInput={
                                                            authorisedSignatoryDobInput
                                                        }
                                                        displayFormat="DD/MM/YYYY"
                                                        disabled={isViewMode}
                                                        isOutsideRange={day =>
                                                            day.isAfter(
                                                                moment().endOf(
                                                                    'day'
                                                                )
                                                            )
                                                        }
                                                    />
                                                )
                                                 : item.name ===
                                                'aadharNumber' ? (
                                                    <Field
                                                        name={item.name}
                                                        type={item.type}
                                                        id={item.name}
                                                        component={
                                                            FormElems.Input
                                                        }
                                                        placeholder={`Enter last 4 Digits of Aadhar Number`}
                                                        disabled={
                                                            item.disabled ||
                                                            isViewMode
                                                        }
                                                    />
                                                )
                                                : item.name ===
                                                    'pinCode' ? (
                                                        <Field
                                                            onChange={capturePincodeFun}
                                                            name={item.name}
                                                            type={item.type}
                                                            id={item.name}
                                                            component={
                                                                FormElems.Input
                                                            }
                                                            placeholder={`Enter 6 Digits of Pin Code`}
                                                            disabled={
                                                                item.disabled ||
                                                                isViewMode
                                                            }
                                                        />
                                                    ) 
                                                : item.name ===
                                                  'relationshipManagerId' ? (
                                                    <Field
                                                        name={item.name}
                                                        placeholder={`Enter ${item.label}`}
                                                        id={item.name}
                                                        data={
                                                            staticData
                                                                ?.staticInfo
                                                                ?.relationshipManagers ||
                                                            []
                                                        }
                                                        labelField="name"
                                                        valueField="value"
                                                        component={
                                                            FormElems.Select
                                                        }
                                                        label={`Enter ${item.label}`}
                                                        disabled={isViewMode}
                                                    />
                                                ) : item.type === 'select' ? (
                                                    <>
                                                        <Field
                                                            name={item.name}
                                                            placeholder={`Enter ${item.label}`}
                                                            id={item.name}
                                                            data={
                                                                item.data || []
                                                            }
                                                            labelField="name"
                                                            valueField="value"
                                                            component={
                                                                FormElems.Select
                                                            }
                                                            label={`Enter ${item.label}`}
                                                            disabled={
                                                                isViewMode
                                                            }
                                                        />
                                                    </>
                                                ) : item.name ===
                                                  'merchantCategory' ? (
                                                    <Field
                                                        name={item.name}
                                                        type={item.type}
                                                        id={item.name}
                                                        component={
                                                            FormElems.Input
                                                        }
                                                        placeholder={`Enter ${item.label}`}
                                                        disabled={
                                                            isViewMode ||
                                                            item.disabled
                                                        }
                                                    />
                                                ) : item.name === 'businessType' && item.type === 'select' ? (
                                                    <Field
                                                        name={item.name}
                                                        placeholder={`Enter ${item.label}`}
                                                        id={item.name}
                                                        data={item.data || []}
                                                        labelField="name"
                                                        valueField="value"
                                                        value={item.name} // Controlled value
                                                        onChange={handleBusinessTypeChange}
                                                        onSelect={handleBusinessTypeChange}
                                                        component={
                                                            FormElems.Select
                                                        }
                                                        label={`Enter ${item.label}`}
                                                        disabled={isViewMode}
                                                        ref={fieldRef} // Attach the ref here
                                                    />
                                                ) : item.type === 'select' &&  item.name !== 'businessType' ? (
                                                    <Field
                                                        name={item.name}
                                                        placeholder={`Enter ${item.label}`}
                                                        id={item.name}
                                                        data={item.data || []}
                                                        labelField="name"
                                                        valueField="value"
                                                        component={
                                                            FormElems.Select
                                                        }
                                                        label={`Enter ${item.label}`}
                                                        disabled={isViewMode}
                                                    />
                                                ) : item.type === 'radio' ? (
                                                    <Field
                                                        name={item.name}
                                                        wrapperClass="buttonMode"
                                                        options={item.options}
                                                        valueField="value"
                                                        labelField="name"
                                                        component={
                                                            FormElems.Radio
                                                        }
                                                        isDisabled={isViewMode}
                                                    />
                                                ) : (
                                                    <Field
                                                        name={item.name}
                                                        type={item.type}
                                                        id={item.name}
                                                        component={
                                                            FormElems.Input
                                                        }
                                                        placeholder={`Enter ${item.label}`}
                                                        disabled={
                                                            item.disabled ||
                                                            isViewMode
                                                        }
                                                    />
                                                )}
                                            </div>
                                        );
                                    })}
                                </li>

                                <li>
                                    {multipleValuesFields.map((item, index) => {
                                        return (
                                            <div
                                                className="form-section"
                                                key={index}
                                            >
                                                <FieldArray
                                                    name={item.name}
                                                    configuration={item}
                                                    component={
                                                        renderSingleField
                                                    }
                                                    isViewMode={isViewMode}
                                                />
                                            </div>
                                        );
                                    })}
                                </li>
                            </>
                        }
                    />

                    <li>
                        <Accordion
                            customClass="rounded-accordion"
                            upperComponent={
                                <h2 className="accordion-tile">UBO Details</h2>
                            }
                            lowerComponent={
                                <>
                                    <FieldArray
                                        name="uboDetails"
                                        component={uboDetailsInput}
                                        isEditMode={isEditMode}
                                        isViewMode={isViewMode}
                                        uploadImageAndGetURL={
                                            uploadImageAndGetURL
                                        }
                                        handleViewClick={handleViewClick}
                                        actions={actions}
                                        initialData={initialValues}
                                    />
                                </>
                            }
                        />
                    </li>

                    {
                        
                    (selectedBusinessType) && <Accordion
                        customClass="rounded-accordion"
                        upperComponent={
                            <h2 className="accordion-tile">MLE KYC Document</h2>
                        }
                        lowerComponent={
                            <>
                                { selectedBusinessType === 'Individual' ? 
                                (
                                    <li>
                                    {singleMultipleUploadFieldsIndividual.map((item, index) => {
                                        return (
                                            <div
                                                className="form-section"
                                                key={index}
                                            >
                                                <FieldArray
                                                    name={item.name}
                                                    configuration={item}
                                                    component={
                                                        RenderMultiUpload
                                                    }
                                                    isViewMode={isViewMode}
                                                    uploadImageAndGetURL={
                                                        uploadImageAndGetURL
                                                    }
                                                    isMultiLevelField={true}
                                                    handleViewClick={
                                                        handleViewClick
                                                    }
                                                    docUrls={multipleDocUrls}
                                                    setDocUrls={
                                                        setMultipleDocUrls
                                                    }
                                                    errors = {errors[item.name] ? errors[item.name] : ''}
                                                    resetFieldError = {resetFieldError}
                                                />
                                                
                                            </div>
                                        );
                                    })}
                                </li>   
                                )
                                :
                                selectedBusinessType === 'sole proprietorship' ?
                                (
                                    <>
                                        <p className='sole-prop-heading'>Note: Atleast one document is required from GST or Proof of Business 1 or Proof of Business 2</p>
                                        <li>
                                        {singleMultipleUploadFieldsSoleProp.map((item, index) => {
                                            return (
                                                <div
                                                    className="form-section"
                                                    key={index}
                                                >
                                                    <FieldArray
                                                        name={item.name}
                                                        configuration={item}
                                                        component={
                                                            RenderMultiUpload
                                                        }
                                                        isMultiLevelField={true}
                                                        isViewMode={isViewMode}
                                                        uploadImageAndGetURL={
                                                            uploadImageAndGetURL
                                                        }
                                                        handleViewClick={
                                                            handleViewClick
                                                        }
                                                        docUrls={multipleDocUrls}
                                                        setDocUrls={
                                                            setMultipleDocUrls
                                                        }
                                                        errors = {errors[item.name] ? errors[item.name] : ''}
                                                        resetFieldError = {resetFieldError}
                                                        selectedBusinessType={selectedBusinessType}
                                                    />
                                                    
                                                </div>
                                            );
                                        })}
                                    </li>
                                </>   
                                )
                                :
                                (
                                    <li className="form-section">
                                        {getFilteredSingleUploadFields(sortedFields).map((item, index) => {
                                            return (
                                                <div
                                                    className="single-form-section"
                                                    key={index}
                                                >
                                                    <FieldArray
                                                        name={item.name}
                                                        configuration={item}
                                                        component={
                                                            RenderMultiUpload
                                                        }
                                                        isViewMode={isViewMode}
                                                        onlySingleFile = {true}
                                                        isMultiLevelField={false}
                                                        uploadImageAndGetURL={
                                                            uploadImageAndGetURL
                                                        }
                                                        handleViewClick={
                                                            handleViewClick
                                                        }
                                                        docUrls={multipleDocUrls}
                                                        setDocUrls={
                                                            setMultipleDocUrls
                                                        }
                                                        mutateFormData={
                                                            mutateFormData
                                                        }
                                                        errors = {errors[item.name] ? errors[item.name] : ''}
                                                        resetFieldError = {resetFieldError}
                                                    />
                                                
                                                </div>
                                            );
                                        })}
                                    </li>
                                )
                            }
                                
                            
                                                        
                            </>
                        }
                    /> }

                    <li className="form-section remark-section">
                        <div className="form-field">
                            <p className="label">KYC Status
                            <span className="required-asterisk">*</span>
                            </p>
                            <Field
                                name="kycStatus"
                                wrapperClass="buttonMode"
                                options={nameValueOptions([
                                    'COMPLETE',
                                    'PENDING',
                                    'EXPIRED',
                                ])}
                                valueField="value"
                                labelField="name"
                                component={FormElems.Radio}
                                isDisabled={isViewMode}
                            />
                        </div>
                        <div className="form-field">
                            <p className="label">Remarks
                            </p>
                            
                            <Field
                                name="remarks"
                                type="text"
                                id="remarks"
                                component={FormElems.TextArea}
                                placeholder={`Enter remarks`}
                                disabled={isViewMode}
                            />
                        </div>
                    </li>

                    {merchantLegalEntityData.error &&
                    merchantLegalEntityData.error.errorMessage ? (
                        <Alert customClass="error-msg">
                            {merchantLegalEntityData.error.errorMessage}
                        </Alert>
                    ) : null}

                    {formError ? (
                        <Alert customClass="error-msg">{formError}</Alert>
                    ) : null}

                    <li className="form-section action">
                        <FormElems.Button
                            id="next-btn"
                            buttonType="primary"
                            type="submit"
                            text="Submit"
                        />
                    </li>
                </ul>
            </form>
        </div>
    );
};

MerchantLegalEntityMutate.propTypes = {
    actions: PropTypes.object,
    isViewMode: PropTypes.bool,
    handleSubmit: PropTypes.func,
    isEditMode: PropTypes.bool,
    history: PropTypes.func,
    mutateFormData: PropTypes.object,
    initialValues: PropTypes.object,
    merchantLegalEntityData: PropTypes.object,
    staticData: PropTypes.object,
};

const renderSingleField = ({
    fields,
    meta: { error, submitFailed },
    auth,
    isViewMode,
    configuration,
}) => {
    if (fields.length <= 0) {
        fields.push();
    }

    return (
        <div className="field-array-section">
            <div className="field-list-section">
                {fields.map((item, index) => (
                    <>
                        <div className="field-list">
                            <div className="form-field">
                                {index > 0 ? (
                                    <></>
                                ) : (
                                    <p className="label">
                                        {configuration.label}
                                        {configuration?.required && (
                                            <span className="required-asterisk">*</span>
                                        )}
                                    </p>
                                )}
                                <Field
                                    name={`${item}`}
                                    id={`${item}`}
                                    type={configuration.props.type}
                                    component={FormElems.Input}
                                    placeholder={
                                        configuration.props.placeholder
                                    }
                                    disabled={isViewMode}
                                />
                            </div>
                            <div className="action-container">
                                <div className="action">
                                    {!(isViewMode || index === 0) && (
                                        <FormElems.Button
                                            type="button"
                                            text={'x Remove'}
                                            buttonType="secondary"
                                            id={`removeNumber-${index}`}
                                            customClass="remove-button"
                                            handleClick={() =>
                                                fields.remove(index)
                                            }
                                            disabled={isViewMode}
                                        />
                                    )}
                                </div>
                                <div className="action">
                                    {!isViewMode &&
                                        index === fields.length - 1 &&
                                        !configuration.onlySingleValue && (
                                            <FormElems.Button
                                                type="button"
                                                buttonType="secondary"
                                                id="add-field"
                                                text={`+ Add ${configuration.label}`}
                                                customClass="add-button"
                                                isDisable={fields.length === 10}
                                                handleClick={() => {
                                                    fields.push();
                                                }}
                                            />
                                        )}
                                </div>
                            </div>
                        </div>
                    </>
                ))}
            </div>
        </div>
    );
};

renderSingleField.propTypes = {
    fields: PropTypes.object,
    meta: PropTypes.object,
    auth: PropTypes.object,
    configuration: PropTypes.object,
    uniqueId: PropTypes.object,
    isViewMode: PropTypes.bool,
};

const RenderMultiUpload = ({
    fields,
    meta: { error, submitFailed },
    auth,
    isViewMode,
    configuration,
    handleViewClick,
    uploadImageAndGetURL,
    docUrls,
    setDocUrls,
    onlySingleFile,
    isMultiLevelField,
    previousLevelId,
    mutateFormData,
    errors,
    resetFieldError,
    selectedBusinessType
}) => {

    useEffect(() => {
        if(onlySingleFile || !isMultiLevelField){
           
            fields.removeAll();
        }
    }, [, isMultiLevelField, onlySingleFile])

    const mandatoryCount = configuration?.props?.multiple || 0;

    const handleFileChange = (name, value, index) => {
        const newDocMap = { ...docUrls };
        if(newDocMap[configuration.name] && newDocMap[configuration.name][index]){

        }else{
            newDocMap[configuration.name] = [];
        }
        if (value) {
            newDocMap[configuration.name][index] = value;
            setDocUrls(newDocMap);
            // Clear the error for this field
            resetFieldError(configuration.name);
        }
        else{
            newDocMap[configuration.name][index] = null;
            setDocUrls(newDocMap);
        }
    };

    if (fields.length <= 0) {
        fields.push();
    }

    
    const handleAddButtonClick = () => {

        if (fields.length + 1 == configuration?.props?.count) {
            toast.error(`Maximum number of uploads for ${configuration.label} has been reached`);
        } 

        fields.push();
        
    };

    return (
        <div
            className={`field-array-section ${
                onlySingleFile ? 'no-border' : ''
            } form-section`}
        >
            <div className="field-list-section">
                {fields.map((item, index) => (
                    <>
                        <div className="field-list">
                            <div className="form-field">
                                {index > 0 ? (
                                    <></>
                                ) : (
                                    <p className="label">
                                        {configuration.label}{' '}
                                        {configuration?.props?.required && (
                                            <span className="required-asterisk">*</span>
                                        )}
                                        
                                        {/* {configuration.name ===
                                        'AUTHORISED_SIGNATORY_ADDRESS'
                                            ? `( ${mutateFormData?.values?.authorisedSignatoryAddressProofType} )`
                                            : ''} */}
                                    </p>
                                )}
                                <Field
                                    handleChange={(name, value) =>
                                        handleFileChange(name, value, index)
                                    }
                                    uploadImageAndGetURL={uploadImageAndGetURL}
                                    docUrl={
                                        docUrls[configuration.name] && docUrls[configuration.name][index]
                                            ? docUrls[configuration.name][index]
                                            : ''
                                    }
                                    handleView={handleViewClick}
                                    name={
                                        isMultiLevelField
                                            ? `${previousLevelId}.${item}`
                                            : item
                                    }
                                    id={
                                        isMultiLevelField
                                            ? `${previousLevelId}.${item}`
                                            : item
                                    }
                                    type="file"
                                    component={FormElems.UploadElement}
                                    labelName={`${configuration.label} ${
                                        index > 0 ? `- ${index}` : ''
                                    }`}
                                    placeholder={
                                        configuration.props.placeholder
                                    }
                                    disabled={isViewMode}
                                    accept={configuration.props.accept}
                                    allowedExtensions={allowedExtensions}
                                    MLEerrorMessage = "Oops! Only Images and PDF files are allowed for upload."
                                    MaxFileSize = {5}
                                />
                                {errors && <div className="error-message-multiplefields">{errors}</div>}
                            </div>
                            {
                            
                            !onlySingleFile ? (
                                
                                <div className="action-container">
                                    <div className="action">
                                        {!(
                                            isViewMode ||
                                            onlySingleFile ||
                                            index === 0
                                        ) && (
                                            <FormElems.Button
                                                type="button"
                                                text={'x Remove'}
                                                buttonType="secondary"
                                                id={`removeNumber-${index}`}
                                                customClass="remove-button"
                                                handleClick={() =>
                                                    fields.remove(index)
                                                }
                                                disabled={isViewMode}
                                            />
                                        )}
                                    </div>
                                    <div className="action">
                                        {!(isViewMode || onlySingleFile) &&
                                            
                                            (index === fields.length - 1 && configuration?.props?.count !== 1 && index + 1 !== configuration?.props?.count) && (
                                                <FormElems.Button
                                                    type="button"
                                                    buttonType="secondary"
                                                    id="add-document"
                                                    text={`+ Add ${configuration.label}`}
                                                    customClass="add-button"
                                                    isDisable={
                                                        fields.length === 10
                                                    }
                                                    handleClick={handleAddButtonClick}
                                                />
                                            )}
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    </>
                ))}
            </div>
        </div>
    );
};

RenderMultiUpload.propTypes = {
    fields: PropTypes.object,
    meta: PropTypes.object,
    auth: PropTypes.object,
    configuration: PropTypes.object,
    uniqueId: PropTypes.object,
    isViewMode: PropTypes.bool,
    isEditMode: PropTypes.bool,
    onlySingleFile: PropTypes.bool,
    handleViewClick: PropTypes.func,
    uploadImageAndGetURL: PropTypes.func,
    docUrls: PropTypes.object,
    setDocUrls: PropTypes.func,
    errors: PropTypes.object,
    resetFieldError: PropTypes.object,
    selectedBusinessType: PropTypes.object,
};

const uboDetailsInput = ({
    fields,
    meta: { error, submitFailed },
    auth,
    isViewMode,
    configuration,
    getUboDetails,
    uploadImageAndGetURL,
    handleViewClick,
    actions,
    initialData,
    isEditMode,
}) => {
    if (fields.length <= 0) {
        fields.push();
    }

    return (
        <>
            {fields.map((item, index) => {
                return (
                    <Accordion
                        customClass="rounded-accordion"
                        upperComponent={
                            <h2 className="accordion-tile">
                                UBO {index + 1} Details
                            </h2>
                        }
                        lowerComponent={
                            <UBOForm
                                index={index}
                                field={item}
                                onRemove={removeIndex =>
                                    fields.remove(removeIndex)
                                }
                                isViewMode={isViewMode}
                                uploadImageAndGetURL={uploadImageAndGetURL}
                                handleViewClick={handleViewClick}
                                actions={actions}
                                isEditMode={isEditMode}
                                initialData={
                                    initialData &&
                                    initialData.uboDetails &&
                                    initialData.uboDetails[index]
                                        ? initialData.uboDetails[index]
                                        : {}
                                }
                            />
                        }
                    />
                );
            })}

            <div className="action-container">
                <div className="action">
                    {!isViewMode && (
                        <FormElems.Button
                            type="button"
                            buttonType="secondary"
                            id="add-field"
                            text={`+ Add UBO`}
                            customClass="add-button"
                            isDisable={fields.length === 10}
                            handleClick={() => {
                                fields.push();
                            }}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

const UBOForm = ({
    field,
    onRemove,
    index,
    isViewMode,
    uploadImageAndGetURL,
    handleViewClick,
    actions,
    initialData,
    isEditMode,
}) => {
    const [uboDate, setuboDate] = useState(null);
    const [uboDatefocusedInput, setuboDateFocusedInput] = useState(null);
    const [multipleDocUrls, setMultipleDocUrls] = useState({
        panDocs: [],
        proofOfAddress: [],
        selfie: [],
    });

    useEffect(() => {
        if (initialData.dob) {
            setuboDate(initialData.dob ? moment.unix(initialData.dob) : null);
        }
    }, [initialData.dob]);

    useEffect(() => {
        if (initialData) {
            let initlalMultipleDocUrls = {
                panDocs: initialData.panDocs || [],
                selfie: initialData.selfie || [],
                proofOfAddress: initialData.proofOfAddress || [],
            };
            setMultipleDocUrls(initlalMultipleDocUrls);
        }
    }, [initialData.panDocs]);

    useEffect(() => {
        actions.change(
            'mle-onboarding-form',
            `${field}.docUrls`,
            multipleDocUrls
        );
    }, [multipleDocUrls]);

    useEffect(() => {
        actions.change(
            'mle-onboarding-form',
            `${field}.dob`,
            moment(uboDate)
                .startOf('day')
                .unix()
        );
    }, [uboDate]);

    return (
        <>
            <ul className="form-list">
                <li className="form-section">
                    <div className="form-field">
                        <p className="label">Name</p>
                        <Field
                            name={`${field}.name`}
                            id={`${field}.name`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter Name"
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">UBO PAN</p>
                        <Field
                            name={`${field}.uboPAN`}
                            id={`${field}.uboPAN`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter PAN"
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">UBO DOB (As per PAN)</p>
                        <Field
                            name={`${field}.uboDOBDate`}
                            component={DatePicker}
                            singleDatePicker
                            startDateId={`${field}.uboDOBDate`}
                            onFocusedInput={setuboDateFocusedInput}
                            onSetStartDate={setuboDate}
                            startDate={uboDate}
                            focusedInput={uboDatefocusedInput}
                            displayFormat="DD/MM/YYYY"
                            disabled={isViewMode}
                            isOutsideRange={day =>
                                day.isAfter(moment().endOf('day'))
                            }
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Address</p>
                        <Field
                            name={`${field}.address.addressLine`}
                            id={`${field}.address.addressLine`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter Address"
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Pincode</p>
                        <Field
                            name={`${field}.address.pinCode`}
                            id={`${field}.address.pinCode`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter Pincode"
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">City</p>
                        <Field
                            name={`${field}.address.city`}
                            id={`${field}.address.city`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter City"
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">State</p>
                        <Field
                            name={`${field}.address.state`}
                            id={`${field}.address.state`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter State"
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Email</p>
                        <Field
                            name={`${field}.email`}
                            id={`${field}.email`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter Email"
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">UBO Status</p>
                        <Field
                            name={`${field}.status`}
                            id={`${field}.status`}
                            wrapperClass="buttonMode"
                            defaultSelected="ACTIVE"
                            options={
                                isEditMode
                                    ? nameValueOptions(['ACTIVE', 'INACTIVE'])
                                    : nameValueOptions(['ACTIVE'])
                            }
                            valueField="value"
                            labelField="name"
                            component={FormElems.Radio}
                            isDisabled={isViewMode}
                        />
                    </div>
                </li>
                <li className="form-section">
                    {uboSingleUploadFields.map((item, index) => {
                        return (
                            <div className="single-form-section" key={index}>
                                <FieldArray
                                    name={item.name}
                                    configuration={item}
                                    component={RenderMultiUpload}
                                    isViewMode={isViewMode}
                                    onlySingleFile
                                    uploadImageAndGetURL={uploadImageAndGetURL}
                                    handleViewClick={handleViewClick}
                                    docUrls={multipleDocUrls}
                                    setDocUrls={setMultipleDocUrls}
                                    isMultiLevelField
                                    previousLevelId={field}
                                />
                            </div>
                        );
                    })}
                </li>
            </ul>
            <div className="action-container">
                <div className="action">
                    {!(isViewMode || index === 0) && (
                        <FormElems.Button
                            type="button"
                            text={'x Remove'}
                            buttonType="secondary"
                            id={`removeNumber-${index}`}
                            customClass="remove-button"
                            handleClick={() => onRemove(index)}
                            disabled={isViewMode}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

const mapStateToProps = ({
    auth,
    form,
    staticData,
    merchantLegalEntityData,
}) => ({
    auth,
    mutateFormData: form['mle-onboarding-form'],
    staticData,
    merchantLegalEntityData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            change,
            createMerchantLegalEntityRequest,
            editMerchantLegalEntityRequest,
            fetchMerchantLegalEntityDetailsRequest,
            fetchMerchantLegalEntityDetailsPincodeRequest,
            resetMerchantLegalEntityFormReset,
        },
        dispatch
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'mle-onboarding-form',
            enableReinitialize: true,
            validate,
            initialValues: {
                kycStatus: 'PENDING', // Default value here
            },
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(MerchantLegalEntityMutate)
);
